import { render } from "./InvoicePage.vue?vue&type=template&id=67539f89&scoped=true&ts=true"
import script from "./InvoicePage.ts?vue&type=script&lang=ts"
export * from "./InvoicePage.ts?vue&type=script&lang=ts"

import "./InvoicePage.vue?vue&type=style&index=0&id=67539f89&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67539f89"]])

export default __exports__